import type { Template } from "@/types";

export const LA_06_H0_V6: Template[] = [
    {
        id: "la-06-h0v6-01",
        name: "LA 01 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 133, y: 54, width: 262, height: 432, rotation: 0, imageRotation: 0 },
            { id: "2", x: 403, y: 54, width: 140, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 403, y: 274, width: 140, height: 212, rotation: 0, imageRotation: 0 },
            { id: "4", x: 810, y: 54, width: 261, height: 432, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1079, y: 54, width: 140, height: 212, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1079, y: 274, width: 140, height: 212, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-02",
        name: "LA 02 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 133, y: 54, width: 143, height: 212, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 274, width: 143, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 284, y: 54, width: 259, height: 432, rotation: 0, imageRotation: 0 },
            { id: "4", x: 810, y: 54, width: 261, height: 432, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1079, y: 54, width: 140, height: 212, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1079, y: 274, width: 140, height: 212, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-03",
        name: "LA 03 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 107, y: 87, width: 227, height: 366, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 87, width: 226, height: 366, rotation: 0, imageRotation: 0 },
            { id: "3", x: 821, y: 54, width: 261, height: 432, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1090, y: 54, width: 101, height: 139, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1090, y: 202, width: 101, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1090, y: 348, width: 101, height: 138, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-04",
        name: "LA 04 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 42, y: 116, width: 192, height: 309, rotation: 0, imageRotation: 0 },
            { id: "2", x: 242, y: 116, width: 192, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 442, y: 116, width: 191, height: 309, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 116, width: 192, height: 309, rotation: 0, imageRotation: 0 },
            { id: "5", x: 919, y: 116, width: 191, height: 309, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1118, y: 116, width: 191, height: 309, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-05",
        name: "LA 05 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 100, width: 219, height: 342, rotation: 0, imageRotation: 0 },
            { id: "2", x: 227, y: 100, width: 219, height: 342, rotation: 0, imageRotation: 0 },
            { id: "3", x: 454, y: 100, width: 219, height: 342, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 100, width: 219, height: 342, rotation: 0, imageRotation: 0 },
            { id: "5", x: 908, y: 100, width: 218, height: 342, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1134, y: 100, width: 218, height: 342, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-06",
        name: "LA 06 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 42, y: 201, width: 192, height: 297, rotation: 0, imageRotation: 0 },
            { id: "2", x: 242, y: 201, width: 191, height: 297, rotation: 0, imageRotation: 0 },
            { id: "3", x: 441, y: 201, width: 191, height: 297, rotation: 0, imageRotation: 0 },
            { id: "4", x: 718, y: 201, width: 192, height: 297, rotation: 0, imageRotation: 0 },
            { id: "5", x: 918, y: 201, width: 191, height: 297, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1117, y: 201, width: 191, height: 297, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-07",
        name: "LA 07 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 362, height: 541, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 521, y: 41, width: 152, height: 226, rotation: 0, imageRotation: 0 },
            { id: "3", x: 521, y: 275, width: 152, height: 226, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 41, width: 152, height: 226, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 275, width: 152, height: 226, rotation: 0, imageRotation: 0 },
            { id: "6", x: 990, y: 0, width: 362, height: 541, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-08",
        name: "LA 08 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 364, height: 541, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 437, y: 41, width: 162, height: 225, rotation: 0, imageRotation: 0 },
            { id: "3", x: 437, y: 274, width: 162, height: 225, rotation: 0, imageRotation: 0 },
            { id: "4", x: 754, y: 41, width: 162, height: 225, rotation: 0, imageRotation: 0 },
            { id: "5", x: 754, y: 274, width: 162, height: 225, rotation: 0, imageRotation: 0 },
            { id: "6", x: 988, y: 0, width: 364, height: 541, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-09",
        name: "LA 09 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 68, y: 80, width: 124, height: 188, rotation: 0, imageRotation: 0 },
            { id: "2", x: 68, y: 276, width: 124, height: 187, rotation: 0, imageRotation: 0 },
            { id: "3", x: 200, y: 80, width: 279, height: 383, rotation: 0, imageRotation: 0 },
            { id: "4", x: 487, y: 80, width: 121, height: 188, rotation: 0, imageRotation: 0 },
            { id: "5", x: 487, y: 276, width: 121, height: 187, rotation: 0, imageRotation: 0 },
            { id: "6", x: 968, y: 0, width: 384, height: 541, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h0v6-10",
        name: "LA 10 - H0V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 376, height: 541, rotation: 0, imageRotation: 0 },
            { id: "2", x: 739, y: 80, width: 279, height: 383, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1026, y: 80, width: 129, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1026, y: 276, width: 129, height: 187, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1163, y: 80, width: 129, height: 188, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1163, y: 276, width: 129, height: 187, rotation: 0, imageRotation: 0 }
        ],
    }
];